import { Outlet } from 'react-router-dom';
import { SidebarProvider } from 'shared/contexts/sidebar-provider';
import { Sidebar } from '../components/sidebar';
import { Wrapper } from '../../ogp/layouts/helpers';

const BaseLayout = () => {
  return (
    <>
      <SidebarProvider>
        <Sidebar />
      </SidebarProvider>
      <Wrapper>
        <Outlet />
      </Wrapper>
    </>
  );
};

export { BaseLayout };
